import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

// Endpoints whose 401 genuinely means "session is dead — log the user out".
// Any other endpoint returning 401 is treated as a per-call permission/transient
// problem and the token is preserved. This is critical for long-running flows
// (e.g. SME video rendering polls /lessons/{id}/jobs/{id} every 2.2s — a single
// transient 401 during a backend cold-start used to silently nuke the JWT and
// kick the user back to /login).
const SESSION_KILLER_PATTERNS = [
    /\/api\/auth\/me$/,
    /\/api\/auth\/refresh$/,
];

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401) {
            const isSessionEndpoint = SESSION_KILLER_PATTERNS.some((rx) => rx.test(url));
            if (isSessionEndpoint) {
                localStorage.removeItem("token");
            }
            // For every other endpoint we leave the token alone and let the
            // calling code surface the error to the user. This prevents
            // transient 401s during background polling (video render jobs,
            // attendance polling, etc.) from silently logging users out.
        }
        return Promise.reject(err);
    },
);

export default api;
